var $7ce81748245d01d0$exports = {};
const $7ce81748245d01d0$var$featureSelector = document.querySelector(".feature-selector");
const $7ce81748245d01d0$var$features = document.querySelectorAll(".feature");
if ($7ce81748245d01d0$var$featureSelector) $7ce81748245d01d0$var$featureSelector.addEventListener("change", (e)=>{
    const selectedFeature = e.target.value;
    $7ce81748245d01d0$var$features.forEach((feature)=>{
        if (feature.id === `${selectedFeature}-feature`) feature.classList.remove("hidden");
        else feature.classList.add("hidden");
    });
});
const $7ce81748245d01d0$var$copyrightYear = document.getElementById("copyright-year");
if ($7ce81748245d01d0$var$copyrightYear) $7ce81748245d01d0$var$copyrightYear.textContent = new Date().getFullYear().toString();


//# sourceMappingURL=hexee-pro.38edda1e.js.map
